export enum EDumpReasonType {
  BeforeRun = 'before_run',
  AfterRun = 'after_run'
}
